import React, { useState } from "react"
import FadeIn from "./fadeIn"

import styles from "../../styles/components/landing/joinForm.module.scss"
import { FaCheckCircle } from "react-icons/fa"

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const JoinForm = () => {
  const [showSuccess, setShowSuccess] = useState(false)
  const [name, setName] = useState("")
  const [telephone, setTelephone] = useState("")
  const [email, setEmail] = useState("")

  const handleSubmit = e => {
    e.preventDefault()
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": "join",
        name,
        telephone,
        email,
      }),
    })
      .then(() => setShowSuccess(true))
      .then(() => {
        setTimeout(() => {
          setShowSuccess(false)
        }, 5000)
      })
      .catch(error => alert(error))
  }

  return (
    <React.Fragment>
      {showSuccess ? (
        <div>
          <h4 className={styles.successTitle}>
            <FaCheckCircle />
          </h4>
          <p className={styles.successText}>
            Thank you! You'll receive an email shortly.
          </p>
        </div>
      ) : (
        <div className={styles.form}>
          <form
            name="join"
            method="post"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            onSubmit={handleSubmit}
          >
            <input type="hidden" name="form-name" value="join" />
            <div className={styles.inputDiv}>
              <input
                placeholder="Full Name"
                name="name"
                type="text"
                value={name}
                required
                onChange={e => setName(e.target.value)}
              ></input>
            </div>
            <div className={styles.inputDiv}>
              <input
                placeholder="Telephone"
                name="telephone"
                type="tel"
                value={telephone}
                required
                onChange={e => {
                  console.log(e.target.value)
                  setTelephone(e.target.value)
                }}
              ></input>
            </div>
            <div className={styles.inputDiv}>
              <input
                placeholder="Email Address"
                name="email"
                type="email"
                value={email}
                required
                onChange={e => setEmail(e.target.value)}
              ></input>
            </div>
            <FadeIn delay={500}>
              <button type="submit" className={styles.btn}>
                Join Now
              </button>
            </FadeIn>
          </form>
        </div>
      )}
    </React.Fragment>
  )
}

export default JoinForm
